import {hoistCmp, HoistModel, HoistProps, SelectOption, uses} from '@xh/hoist/core';
import {menuButton} from '@xh/hoist/desktop/cmp/menu';
import classNames from 'classnames';
import './WidgetToolbarButton.scss';
import './WidgetToolbarSelect.scss';

interface WidgetToolbarSelectProps extends HoistProps<HoistModel> {
    /** Heading shown above the options. */
    title: string;
    options: SelectOption[];
    /** Name of the bindable property on the model holding the selected value. */
    bind: string;
}

/** Compact widget toolbar picker - shows the current option's label and opens a menu of options. */
export const widgetToolbarSelect = hoistCmp.factory<WidgetToolbarSelectProps>({
    model: uses('*'),
    render({title, options, model, bind, className}) {
        const value = model[bind],
            current = options.find(o => o.value === value);

        return menuButton({
            className: classNames('rzx-widget-toolbar-button', 'rzx-widget-toolbar-select', className),
            text: current?.label ?? value,
            icon: null,
            minimal: true,
            menuPosition: 'top',
            menuClassName: 'rzx-widget-toolbar-select__menu',
            menuItems: [
                {heading: title},
                ...options.map(o => ({
                    text: o.label,
                    active: o.value === value,
                    actionFn: () => model.setBindable(bind, o.value)
                }))
            ]
        });
    }
});
